import { Roles } from '@/utils/roles';
import UserEditPage from '@/modules/users/pages/edit';
import PageCalendar from '@/modules/users/pages/calendar';
import { FeaturesEnum } from '@utils/features';
import { UserCreatePage, UserListPage } from '../elements';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';

const ROOT = 'users';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: ROOT,
    icon: 'mdi:users-outline',
    feature: FeaturesEnum.USERS,
    custom: true,
    settings: true,
    onlyOption: false,
    guard: [Roles.WAITRESS],
  },
  list: {
    path: pathJoin(root, [ROOT, 'list']),
    element: UserListPage,
    guard: [Roles.ADMIN, Roles.ATM],
    params: undefined,
    feature: FeaturesEnum.USERS_LIST,
    title: 'list',
    show: true,
  },
  new: {
    path: pathJoin(root, [ROOT, 'new']),
    element: UserCreatePage,
    label: 'new',
    feature: FeaturesEnum.USERS_CREATE,
    show: false,
    guard: [Roles.ADMIN],
    settings: true,
  },
  edit: {
    path: (name: string) => pathJoin(root, [ROOT, name]),
    element: UserEditPage,
    feature: FeaturesEnum.USERS_EDIT,
    params: ':uid',
    guard: [Roles.ADMIN],
  },

  calendar: {
    path: pathJoin(root, [ROOT, 'calendar']),
    element: PageCalendar,
    title: 'calendar',
    feature: FeaturesEnum.USERS_CALENDAR,
    show: true,
    guard: [Roles.WAITRESS, Roles.ADMIN, Roles.ATM],
  },
});

export const pathUsers = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
